module.exports = __webpack_public_path__ + "static/media/facebook.4e826735.svg";